import {Link,useLocation} from 'react-router-dom';
import {BookOpen} from 'lucide-react';
import {GUIDE_ROUTES,topicForPath} from './guidePolicy';
export default function PageHelpLink({portal='erp'}){
 const location=useLocation();
 return <Link to={`${GUIDE_ROUTES[portal]}?topic=${topicForPath(location.pathname)}`} target="_blank" rel="noopener noreferrer" title="How to use this page — opens in a new tab" aria-label="Guide for this page (opens in a new tab)" className="inline-flex shrink-0 items-center gap-2 rounded-xl border border-amber-400/20 bg-amber-400/5 px-3 py-2 text-sm text-amber-200 hover:bg-amber-400/10"><BookOpen size={17}/><span>Guide</span></Link>;
}
